<template lang="pug">
    .row
        .col-12.text-center
            img(
                :style='"height: 200px"'
                :src='files.length?files[0].url: baseURL + "/img/placeholder.png"'
            )
            br
            file-upload(
                ref='Uploader'
                :name='name',
                :extensions='extensions',
                :accept='accept',
                v-model='files'
                :drop='drop',
                @input-filter="inputFilter",
                @input-file="inputFile",
            )
        .col-12.text-center
            template(v-if='!isEdit')
                label.btn.btn-sm.btn-info.m-0(:for='name') Upload Image
            template(v-else)
                button.btn.btn-sm.btn-danger(type='button' @click.prevent='removeFile') Remove
                label.btn.btn-sm.btn-info.m-0.ml-2(:for='name') Change Image

        //- .col-12.text-center(v-show='isEdit')
            label.btn.btn-sm.btn-info.m-0(:for='name') Change Image

</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    value: {
      default: null,
    },
    extensions: {
      default: 'gif,jpg,jpeg,png,webp',
    },
    accept: {
      default: 'image/png,image/gif,image/jpeg,image/webp',
    },
    name: {
      default: 'file-uploader',
    },
    drop: {
      default: false,
    },
  },

  name: 'single-uploader',

  data() {
    return {
      isEdit: false,
      files: [],
    };
  },

  watch: {
    value: function (newVal, _oldVal) {
      if (!newVal) {
        this.removeFile();
      }
    },
  },

  computed: {
    ...mapGetters('system', {
      baseURL: 'getBaseUrl',
    }),
  },

  methods: {
    /**
     * [add description]
     */
    add(file) {
      const addedFile = this.$refs.Uploader.add(file);
      this.$emit('input', addedFile);
    },

    /**
     * [removeFile description]
     * @return {[type]} [description]
     */
    removeFile() {
      this.$refs.Uploader.clear();
    },

    /**
     * [inputFile description]
     * @param  {[type]} newFile [description]
     * @param  {[type]} oldFile [description]
     * @param  {[type]} prevent [description]
     * @return {[type]}         [description]
     */
    inputFile(newFile, oldFile, _prevent) {
      if (newFile && !oldFile) {
        this.$nextTick(function () {
          this.isEdit = true;
        });
      }
      if (!newFile && oldFile) {
        this.isEdit = false;
      }
      this.$emit('input', newFile);
    },

    /**
     * [inputFilter description]
     * @param  {[type]} newFile [description]
     * @param  {[type]} oldFile [description]
     * @param  {[type]} prevent [description]
     * @return {[type]}         [description]
     */
    inputFilter(newFile, oldFile, _prevent) {
      // if (newFile && !oldFile) {
      // 	if (!/\.(gif|jpg|jpeg|png|webp)$/i.test(newFile.name)) {
      // 		this.alert('Your choice is not a picture')
      // 		return prevent()
      // 	}
      // }
      if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
        newFile.url = '';
        let URL = window.URL || window.webkitURL;
        if (URL && URL.createObjectURL) {
          newFile.url = URL.createObjectURL(newFile.file);
        }
      }
    },
  },
};
</script>

<style lang="css" scoped></style>
